<script lang="ts">
    import Link from "svelte-link";
    import { Card, Col, Row } from "sveltestrap";
    import { href } from "../../../../utils/Constant/Constant";
    import data from "../../../../Data/Ecommerce/Ecommerce.json"
    $: temId = "top-home-tab"
    const handleClick = (id:string) =>{
      temId = id
    }
</script>
<Card>
  <Row class="product-page-main">
    <Col sm="12">
      <ul class="nav nav-tabs border-tab nav-primary mb-0" id="top-tab" role="tablist">
        {#each data.productpagedata as productItem}
          <li class="nav-item">
            <Link class="nav-link {temId === productItem.id ? "active" : ""}" id={productItem.id}  href={href} on:click={()=>handleClick(productItem.id)}>{productItem.name}</Link>
          </li>
        {/each}
      </ul>
      <div class="tab-content" id="top-tabContent">
        {#each data.tabbodydata as productItem}
          <div class="tab-pane fade {temId === productItem.id  ? "active show" : ""}" id={productItem.id} role="tabpanel" aria-labelledby={productItem.id}>
            <p class="mb-0 m-t-20">{productItem.detail}</p>
            {#if productItem.detail2}
              <p class="mb-0 m-t-20">{productItem.detail2}</p>
            {/if}
          </div>
        {/each}
      </div>
    </Col>
  </Row>
</Card>